<ng-container *transloco="let t">
  <!-- WITH PRODUCT -->

  @if (product && product.metadata.faq.length > 0) {
    <section class="product-faq">
      <h2>{{ t('aria_link_faq') }}</h2>

      <span class="fixed-space-4" aria-hidden="true"></span>

      @for (item of product.metadata.faq; track trackByItem(i, item); let i = $index) {
        <div class="item">
          <div class="question" (click)="item.openTab = !item.openTab">
            <span [class.bold]="item.openTab">{{ item.question }}</span>
            <span class="fixed-space-8" aria-hidden="true"></span>
            <popsy-icon-chevron-down
              class="icon gray-01"
              [class.selected]="item.openTab" />
          </div>
          <div class="answer" [class.selected]="item.openTab">
            {{ item.answer }}
          </div>
          <span class="line fill-row"></span>
        </div>
      }
    </section>
  }
</ng-container>
